import { render, staticRenderFns } from "./Termo.vue?vue&type=template&id=4a15994c&scoped=true"
import script from "./Termo.vue?vue&type=script&lang=js"
export * from "./Termo.vue?vue&type=script&lang=js"
import style0 from "./Termo.vue?vue&type=style&index=0&id=4a15994c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15994c",
  null
  
)

export default component.exports